export const STATUS_ASSOCIADO_ATIVO = 1;
export const STATUS_ASSOCIADO_INATIVO = 0;
export const STATUS_ASSOCIADO_IRREGULAR = 2;

export const TIPO_CAMPANHA_MENSAL = 1;
export const TIPO_CAMPANHA_TEMPORADA = 2;

export const TIPO_CAMPANHAS = {
  [TIPO_CAMPANHA_MENSAL]: 'mensal',
  [TIPO_CAMPANHA_TEMPORADA]: 'temporada',
};

export const STATUS_ASSOCIADO = {
  [STATUS_ASSOCIADO_ATIVO]: {
    text: 'Ativo',
    color: 'badge.ativo',
  },
  [STATUS_ASSOCIADO_INATIVO]: {
    text: 'Inativo',
    color: 'badge.inativo',
  },
  [STATUS_ASSOCIADO_IRREGULAR]: {
    text: 'Irregular',
    color: 'badge.irregular',
  },
};

export const STATUS_ENDERECO_ATIVO = true;
export const STATUS_ENDERECO_INATIVO = false;

export const STATUS_ENDERECO = {
  [STATUS_ENDERECO_ATIVO]: {
    text: 'Ativo',
    color: 'badge.ativo',
  },
  [STATUS_ENDERECO_INATIVO]: {
    text: 'Inativo',
    color: 'badge.inativo',
  },
};

export const STATUS_TELEFONE_ATIVO = true;
export const STATUS_TELEFONE_INATIVO = false;

export const STATUS_TELEFONE = {
  [STATUS_TELEFONE_ATIVO]: {
    text: 'Ativo',
    color: 'badge.ativo',
  },
  [STATUS_TELEFONE_INATIVO]: {
    text: 'Inativo',
    color: 'badge.inativo',
  },
};

export const STATUS_DEPENDENTE_ATIVO = true;
export const STATUS_DEPENDENTE_INATIVO = false;

export const TIPO_APROVACAO_CADASTRO = 0;
export const TIPO_APROVACAO_DEPENDENTE = 1;
export const TIPO_APROVACAO_TROCA_UNIDADE = 2;

export const STATUS_APROVACAO_PENDENTE = 0;
export const STATUS_APROVACAO_APROVADO = 1;
export const STATUS_APROVACAO_REPROVADO = 2;

export const STATUS_DEPENDENTE = {
  [STATUS_DEPENDENTE_ATIVO]: {
    text: 'Ativo',
    color: 'badge.ativo',
  },
  [STATUS_DEPENDENTE_INATIVO]: {
    text: 'Inativo',
    color: 'badge.inativo',
  },
};

export const MASCULINO = 'M';
export const FEMININO = 'F';
export const OUTRO = 'O';

export const SEXO = {
  [MASCULINO]: 'Masculino',
  [FEMININO]: 'Feminino',
  [OUTRO]: 'Outro',
};

export const TIPO_UNIDADE_APARTAMENTO = 0;
export const TIPO_UNIDADE_CASA = 1;
export const TIPO_UNIDADE_KITNET = 2;
export const TIPO_UNIDADE_CADEIRANTE = 3;

export const TIPO_UNIDADE_LABEL = {
  [TIPO_UNIDADE_APARTAMENTO]: 'Apartamento',
  [TIPO_UNIDADE_CASA]: 'Casa',
  [TIPO_UNIDADE_KITNET]: 'Kitnet',
  [TIPO_UNIDADE_CADEIRANTE]: 'Cadeirante',
};

export const TIPOS_UNIDADES = [
  {
    label: 'Apartamento',
    value: TIPO_UNIDADE_APARTAMENTO,
  },
  {
    label: 'Casa',
    value: TIPO_UNIDADE_CASA,
  },
  {
    label: 'Kitnet',
    value: TIPO_UNIDADE_KITNET,
  },
  {
    label: 'Cadeirante',
    value: TIPO_UNIDADE_CADEIRANTE,
  },
];

export const STATUS_SORTEIO_INICIADO = 0;
export const STATUS_SORTEIO_EM_DESENVOLVIMENTO = 1;
export const STATUS_SORTEIO_INSCRICOES_ENCERRADAS = 2;
export const STATUS_SORTEIO_FINALIZADO = 3;
export const STATUS_SORTEIO_PUBLICADO = 4;

export const STATUS_SORTEIO = [
  { id: STATUS_SORTEIO_INICIADO, label: 'Iniciado' },
  { id: STATUS_SORTEIO_EM_DESENVOLVIMENTO, label: 'Em desenvolvimento' },
  { id: STATUS_SORTEIO_PUBLICADO, label: 'Publicado' },
  { id: STATUS_SORTEIO_INSCRICOES_ENCERRADAS, label: 'Inscrições encerradas' },
  { id: STATUS_SORTEIO_FINALIZADO, label: 'Finalizado' },
];

export const STATUS_USER = [
  { id: true, label: 'Ativo' },
  { id: false, label: 'Inativo' },
];

export const STATUS_SORTEIO_SELECTOR = {
  [STATUS_SORTEIO_INICIADO]: 'Iniciado',
  [STATUS_SORTEIO_EM_DESENVOLVIMENTO]: 'Em desenvolvimento',
  [STATUS_SORTEIO_PUBLICADO]: 'Publicado',
  [STATUS_SORTEIO_INSCRICOES_ENCERRADAS]: 'Inscrições encerradas',
  [STATUS_SORTEIO_FINALIZADO]: 'Finalizado',
};

export const STATUS_RESULTADO_INSCRITO = 0;
export const STATUS_RESULTADO_GANHOU = 1;
export const STATUS_RESULTADO_NAO_CONTEMPLADO = 2;
export const STATUS_RESULTADO_SUPLENTE = 3;

export const STATUS_RESULTADO = {
  [STATUS_RESULTADO_INSCRITO]: 'Inscrito',
  [STATUS_RESULTADO_GANHOU]: 'Contemplado',
  [STATUS_RESULTADO_SUPLENTE]: 'Suplente',
  [STATUS_RESULTADO_NAO_CONTEMPLADO]: 'Não contemplado',
};

export const STATUS_RESULTADO_COLOR = {
  [STATUS_RESULTADO_GANHOU]: '#4AAC48',
  [STATUS_RESULTADO_SUPLENTE]: '#A37FD2',
  [STATUS_RESULTADO_NAO_CONTEMPLADO]: '#E53E3E',
};

export const STATUS_RESULTADO_OPTIONS = [
  { id: STATUS_RESULTADO_GANHOU, label: 'Contemplado' },
  { id: STATUS_RESULTADO_SUPLENTE, label: 'Suplente' },
  { id: STATUS_RESULTADO_NAO_CONTEMPLADO, label: 'Não contemplado' },
];

export const ADMIN_PROFILE = 'Administrador';
export const REGISTER_PROFILE = 'Cadastro';
export const DEFAULT_PROFILE = 'Associado';
export const REPRESENTANTE_PROFILE = 'Representante';
export const CADASTRO_PROFILE = 'Cadastro';
export const COLONIA_PROFILE = 'Colônia';

export const ADMIN_PROFILE_ID = 1;
export const DEFAULT_PROFILE_ID = 2;
export const REPRESENTANTE_PROFILE_ID = 3;
export const CADASTRO_PROFILE_ID = 4;
export const COLONIA_PROFILE_ID = 5;

export const CAMPANHA_INICIADA = 0;
export const CAMPANHA_EM_ANDAMENTO = 1;
export const CAMPANHA_ENCERRADA = 2;

export const STATUS_CAMPANHA = [
  { id: 0, label: 'Iniciada' },
  { id: 1, label: 'Em andamento' },
  { id: 2, label: 'Encerrada' },
];

export const AREA_ADMINISTRATIVA = 0;
export const AREA_DO_ASSOCIADO = 1;

export const AREA_INSCRICAO = [
  {
    label: 'Área Administrativa',
    value: AREA_ADMINISTRATIVA,
  },
  {
    label: 'Área do Associado',
    value: AREA_DO_ASSOCIADO,
  },
];

export const ORIGEM_INSCRICAO_ASSOCIADO = 0;
export const ORIGEM_INSCRICAO_ADMINISTRATIVO = 1;

export const months = [
  {
    name: 'JAN',
  },
  {
    name: 'FEV',
  },
  {
    name: 'MAR',
  },
  {
    name: 'ABR',
  },
  {
    name: 'MAI',
  },
  {
    name: 'JUN',
  },
  {
    name: 'JUL',
  },
  {
    name: 'AGO',
  },
  {
    name: 'SET',
  },
  {
    name: 'OUT',
  },
  {
    name: 'NOV',
  },
  {
    name: 'DEZ',
  },
];

export const TOTALS_INSCRITOS = 0;
export const TOTALS_SORTEADOS = 1;
export const TOTALS_SUPLENTES = 2;

export const pieChartDataPorSexo = [
  {
    name: 'Feminino',
    y: 20,
  },
  {
    name: 'Masculino',
    y: 80,
  },
];

export const pieChartDataPorPostoGraduacao = [
  {
    name: 'Soldado',
    y: 86,
  },
  {
    name: 'Oficial',
    y: 10,
  },
  {
    name: 'Coronel',
    y: 2,
  },
  {
    name: 'Cabo',
    y: 2,
  },
];

export const pieChartDataPorFaixaEtaria = [
  {
    name: '18-25',
    y: 73,
  },
  {
    name: '25-35',
    y: 20,
  },
  {
    name: '35-45',
    y: 7,
  },
];

export const TOTALS_CHART_FILTERS = [
  {
    id: TOTALS_INSCRITOS,
    label: 'Inscritos',
  },
  {
    id: TOTALS_SORTEADOS,
    label: 'Sorteados',
  },
  {
    id: TOTALS_SUPLENTES,
    label: 'Suplentes',
  },
];

export const INSCRICOES_POR_SEXO = 0;
export const INSCRICOES_POR_POSTO_GRADUACAO = 1;
export const INSCRICOES_POR_FAIXA_ETARIA = 2;

export const INSCRICOES_CHART_FILTERS = [
  {
    id: INSCRICOES_POR_SEXO,
    label: 'Por sexo',
  },
  {
    id: INSCRICOES_POR_POSTO_GRADUACAO,
    label: 'Por posto/graduação',
  },
  {
    id: INSCRICOES_POR_FAIXA_ETARIA,
    label: 'Por faixa etária',
  },
];

export const CUSTOMER_STATUS_NORMAL = 0;
export const CUSTOMER_STATUS_CREDITO_BLOQUEADO = 1;
export const CUSTOMER_STATUS_LIMITE_ATINGIDO = 3;
export const CUSTOMER_STATUS_INADIMPLENTE = 4;
export const CUSTOMER_STATUS_LIMITE_ATINGIDO_INADIMPLENTE = 5;
export const CUSTOMER_STATUS_ENCERROU_ATIVIDADES = 6;
export const CUSTOMER_STATUS_DATA_LIMITE_ATINGIDA = 7;
export const CUSTOMER_STATUS_CADASTRO_INATIVO = 8;
export const CUSTOMER_STATUS_CADASTRO_BLOQUEADO = 9;
export const CUSTOMER_STATUS_SUPORTE_BLOQUEADO = 'S';

export const GRAU_DEPENDENTE = [
  {
    label: 'Pais',
    value: 3,
  },
  {
    label: 'Esposa(o)',
    value: 6,
  },
  {
    label: 'Filho(a) menor 21 anos',
    value: 10,
  },
  {
    label: 'Filho(a) maior 21 anos incapaz',
    value: 12,
  },
  {
    label: 'Neto(a)',
    value: 13,
  },
  {
    label: 'Filho(a) Universitario(a)',
    value: 14,
  },
  {
    label: 'Companheiro(a)',
    value: 16,
  },
  {
    label: 'Menor Tutelado reconhecido pela legislação',
    value: 21,
  },
];
